export const analyticsConfig = {
  googleAnalyticsId: "G-7ERLN4VWXE",
};
